/**
 * Build a lookup map keyed by both `value` and `key` (when present).
 * @param {Array<{value: any, key?: string}>} list
 * @param {{ keyAsValue?: boolean }} [opts] - LEGAL_PEOPLE_TYPES maps key → value only
 */
export function buildDic(list, opts = {}) {
  const dic = {}
  for (const obj of list) {
    if (dic[obj.value] === undefined) {
      dic[obj.value] = obj
    }
    if (obj.key !== undefined && dic[obj.key] === undefined) {
      dic[obj.key] = opts.keyAsValue ? obj.value : obj
    }
  }
  return dic
}
